/**
 * Magic Wishlist applies inline style="... !important" after load, which beats
 * stylesheet Custom CSS. Copy computed styles from Sepete ekle so both match.
 */
(function () {
  function syncWishlistButton(button) {
    const reference =
      document.querySelector('.product-form__buttons--with-wishlist .product-form__submit') ||
      document.querySelector('.product-form__submit.button--secondary') ||
      document.querySelector('.product-form__submit');
    if (!reference || !button) return;

    const styles = getComputedStyle(reference);
    const borderWidth = styles.borderTopWidth;
    const borderStyle = styles.borderTopStyle;
    const borderColor = styles.borderTopColor;
    const border =
      borderWidth && borderWidth !== '0px' ? `${borderWidth} ${borderStyle} ${borderColor}` : '0';

    button.style.setProperty('background-color', styles.backgroundColor, 'important');
    button.style.setProperty('color', styles.color, 'important');
    button.style.setProperty('border', border, 'important');
    button.style.setProperty('border-radius', styles.borderRadius, 'important');
    button.style.setProperty('min-height', styles.minHeight, 'important');
    button.style.setProperty('height', '100%', 'important');
    button.style.setProperty('width', '100%', 'important');
    button.style.setProperty('padding', styles.padding, 'important');
    button.style.setProperty('font-size', styles.fontSize, 'important');
    button.style.setProperty('font-family', styles.fontFamily, 'important');
    button.style.setProperty('font-weight', styles.fontWeight, 'important');
    button.style.setProperty('letter-spacing', styles.letterSpacing, 'important');
    button.style.setProperty('box-sizing', 'border-box', 'important');
    button.style.setProperty('display', 'inline-flex', 'important');
    button.style.setProperty('align-items', 'center', 'important');
    button.style.setProperty('justify-content', 'center', 'important');
    button.style.setProperty('gap', '0.6rem', 'important');
    button.style.setProperty('cursor', 'pointer', 'important');
    button.style.setProperty('box-shadow', 'none', 'important');
    button.style.setProperty('margin', '0', 'important');
  }

  function patchWishlistButtons() {
    document
      .querySelectorAll('.product-form__buttons--with-wishlist .wishlist-btn')
      .forEach(syncWishlistButton);
  }

  function init() {
    patchWishlistButtons();

    new MutationObserver(patchWishlistButtons).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        window.requestAnimationFrame(patchWishlistButtons);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
